import { Box, Typography } from "@mui/material";
import React from "react";
import { Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import DatePicker from "../common/DatePicker";

const ControlledDatePicker: React.FC<{
  control: any;
  name: string;
  required?: boolean;
  disabled?: boolean;
  rules?: any;
  label?: string;
  minDate?: any;
  maxDate?: any;
  style?: any;
  variant?: "filled" | "standard" | "outlined" | undefined;
}> = ({
  control,
  name,
  required,
  disabled,
  rules,
  label,
  minDate,
  maxDate,
  style,
  variant = "outlined",
}) => {
  const { t }: any = useTranslation("common");

  return (
    <Controller
      name={name}
      control={control}
      rules={{
        required: { value: required, message: "errors.required" },
        ...rules,
      }}
      render={({
        field: { onChange, value, onBlur },
        formState: { errors },
      }) => (
        <Box>
          <DatePicker
            sx={style}
            minDate={minDate}
            maxDate={maxDate}
            date={value}
            label={label}
            error={Boolean(errors[name])}
            variant={variant}
            sendDataToParent={(e: any) => onChange(e)}
            onBlur={onBlur}
            disabled={disabled}
          />
          {Boolean(errors[name]) && (
            <Typography variant="body2" component="small" color="error">
              {errors[name] ? t(errors?.[name]?.message) : " "}
            </Typography>
          )}
        </Box>
      )}
    />
  );
};

export default ControlledDatePicker;
